import { useEffect, useState } from "react";
import { Select, Field, Input, Textarea } from "@/components/common/Field";
import { FormDialog } from "@/components/vehicles/VehicleFormDialog";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { useRef } from "react";
import { FileField, uploadVehiclePhoto } from "@/lib/uploads";

export const CATEGORIES = ["general", "brakes", "engine", "electrical", "transmission", "tyres", "body", "suspension", "ac", "other"];

export function IssueFormDialog({ open, onClose, vehicleId, onSaved }) {
  const [f, setF] = useState({});
  const [vehicles, setVehicles] = useState([]);
  const fileRef = useRef();
  useEffect(() => {
    if (!open) return;
    setF({ vehicle_id: vehicleId || "", category: "general", priority: "medium" });
    if (!vehicleId) api.get("/vehicles").then((r) => setVehicles(r.data));
  }, [open, vehicleId]);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async () => {
    const { data } = await api.post("/issues", { ...f, odometer_km: f.odometer_km ? Number(f.odometer_km) : null });
    const file = fileRef.current?.files?.[0];
    if (file) { try { await uploadVehiclePhoto(file, { vehicle_id: data.vehicle_id, issue_id: data.id, note: `Issue: ${data.title}` }); } catch { toast.error("Issue saved but photo upload failed"); } }
    toast.success(data.is_recurring ? "Issue reported — flagged as recurring fault" : "Issue reported");
    onSaved(data);
  };
  return (
    <FormDialog open={open} onClose={onClose} title="Report issue" onSubmit={submit} submitLabel="Report" testId="issue-form-dialog">
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        {!vehicleId && <Field label="Vehicle" required className="sm:col-span-2"><Select data-testid="issue-vehicle-select" value={f.vehicle_id || ""} onChange={set("vehicle_id")} required><option value="">Select vehicle</option>{vehicles.map((v) => <option key={v.id} value={v.id}>{v.make} {v.model} · {v.registration_no}</option>)}</Select></Field>}
        <Field label="Title" required className="sm:col-span-2"><Input data-testid="issue-title-input" value={f.title || ""} onChange={set("title")} placeholder="Brake pedal spongy" required /></Field>
        <Field label="Category"><Select data-testid="issue-category-select" value={f.category} onChange={set("category")}>{CATEGORIES.map((c) => <option key={c} value={c}>{c}</option>)}</Select></Field>
        <Field label="Priority"><Select data-testid="issue-priority-select" value={f.priority} onChange={set("priority")}>{["low", "medium", "high", "critical"].map((c) => <option key={c} value={c}>{c}</option>)}</Select></Field>
        <Field label="Odometer (km)" className="sm:col-span-2"><Input data-testid="issue-odometer-input" type="number" value={f.odometer_km || ""} onChange={set("odometer_km")} /></Field>
        <FileField label="Reference photo (optional)" accept="image/*" inputRef={fileRef} testId="issue-photo-input" />
        <Field label="Description" className="sm:col-span-2"><Textarea data-testid="issue-description-input" value={f.description || ""} onChange={set("description")} /></Field>
      </div>
    </FormDialog>
  );
}
